interface IImageSize {
    size: number;
    media: string;
}

interface IImageSizes {
    [key: string]: IImageSize;
}

const SIZES: IImageSizes = {
    s: {
        size: 400,
        media: "(max-width: 399px) 400px"
    },
    m: {
        size: 768,
        media: "(min-width: 400px) and (max-width: 1023px) 768px"
    },
    l: {
        size: 1024,
        media: "(min-width: 1024px) and (max-width: 1199px) 1024px"
    },
    xl: {
        size: 1200,
        media: "(min-width: 1200px) 1200px"
    }
};

function resizeImage(imageUrl: string, size: string) {
    try {
        if (size == "original") {
            return imageUrl;
        } else {
            const matches = imageUrl.match(/(.*\/[\w-_.]+)\.(\w{2,4})/);
            return matches[1] + "_" + size + "." + matches[2];
        }
    } catch (e) {
        return imageUrl;
    }
}

function getSrcsetData(imageUrl: string, sizes: IImageSizes = SIZES) {
    const sizeValues = Object.values(sizes);
    const smallest = sizeValues
        .map((s) => s.size)
        .sort()
        .shift();
    return {
        src: resizeImage(imageUrl, `${smallest}x`),
        srcset: sizeValues
            .map((size) => {
                return resizeImage(imageUrl, `${size.size}x`);
            })
            .join(", "),
        sizes: sizeValues
            .map((size) => {
                return size.media;
            })
            .join(", ")
    };
}

export { resizeImage, getSrcsetData };
